// router
import { createRouter, createWebHistory } from 'vue-router';

import ChangePassword from '@/pages/Auth/ChangePassword.vue';
import FindId from '@/pages/Auth/FindId.vue';
import FindIdResult from '@/pages/Auth/FindIdResult.vue';
import ForgotPassword from '@/pages/Auth/ForgotPassword.vue';
import Login from '@/pages/Auth/Login.vue';
import SignUp from '@/pages/Auth/SignUp.vue';
import SignUpComplete from '@/pages/Auth/SignUpComplete.vue';
import TermsAgreement from '@/pages/Auth/TermsAgreement.vue';
import Benefit from '@/pages/Benefit/Benefit.vue';
import SubscriberBoard from '@/pages/Benefit/SubscriberBoard.vue';
import SubscriberBoardDetail from '@/pages/Benefit/SubscriberBoardDetail.vue';
import CompanyAnalysisJPN from '@/pages/CompanyAnalysis/CompanyAnalysisJPN.vue';
import CompanyAnalysisKR from '@/pages/CompanyAnalysis/CompanyAnalysisKR.vue';
import CompanyAnalysisUSA from '@/pages/CompanyAnalysis/CompanyAnalysisUSA.vue';
import CustomerFeedbackForm from '@/pages/CustomerFeedbackForm/CustomerFeedbackForm.vue';
import Etf from '@/pages/Etf/Etf.vue';
import EtfDetail from '@/pages/Etf/EtfDetail.vue';
import EtfTabList from '@/pages/Etf/EtfTabList.vue';
import Sector from '@/pages/Etf/Sector/Sector.vue';
// component
import Home from '@/pages/Home/Home.vue';
import HotRankingJPN from '@/pages/HotRanking/category/HotRankingJPN.vue';
import HotRankingKR from '@/pages/HotRanking/category/HotRankingKR.vue';
import HotRankingUSA from '@/pages/HotRanking/category/HotRankingUSA.vue';
import HotRankingDetailJPN from '@/pages/HotRanking/HotRankingDetailJPN.vue';
import HotRankingDetailKR from '@/pages/HotRanking/HotRankingDetailKR.vue';
import HotRankingDetailUSA from '@/pages/HotRanking/HotRankingDetailUSA.vue';
import InterestJPN from '@/pages/Interest/InterestJPN.vue';
import InterestKR from '@/pages/Interest/InterestKR.vue';
import InterestUSA from '@/pages/Interest/InterestUSA.vue';
import MajorHolder from '@/pages/MajorHolder/MajorHolder.vue';
import MarketTiming from '@/pages/MarketTiming/MarketTiming.vue';
import MasterInfo from '@/pages/MasterInfo/MasterInfo.vue';
import MasterStocksJPN from '@/pages/MasterStocks/MasterStocksJPN.vue';
import MasterStocksUSA from '@/pages/MasterStocks/MasterStocksUSA.vue';
import MyPage from '@/pages/MyPage/MyPage.vue';
import NewPasswordChange from '@/pages/MyPage/PasswordChange/NewPasswordChange.vue';
import PasswordChange from '@/pages/MyPage/PasswordChange/PasswordChange.vue';
import PrivacyPolicy from '@/pages/MyPage/PrivacyPolicy/PrivacyPolicy.vue';
import CancelSubscriptionConfirm from '@/pages/MyPage/SubscriptionHistory/CancelSubscriptionConfirm.vue';
import CancelSubscriptionForm from '@/pages/MyPage/SubscriptionHistory/CancelSubscriptionForm.vue';
import CancelSubscriptionReason from '@/pages/MyPage/SubscriptionHistory/CancelSubscriptionReason.vue';
import RecurringPaymentsList from '@/pages/MyPage/SubscriptionHistory/RecurringPaymentsList.vue';
import SubscriptionCancellationAppGuide from '@/pages/MyPage/SubscriptionHistory/SubscriptionCancellationAppGuide.vue';
import SubscriptionCancellationComplete from '@/pages/MyPage/SubscriptionHistory/SubscriptionCancellationComplete.vue';
import SubscriptionDetails from '@/pages/MyPage/SubscriptionHistory/SubscriptionDetails.vue';
import SubscriptionHistory from '@/pages/MyPage/SubscriptionHistory/SubscriptionHistory.vue';
import TermsOfService from '@/pages/MyPage/TermsOfService/TermsOfService.vue';
import AccountDeletion from '@/pages/MyPage/UserProfileEdit/AccountDeletion.vue';
import DeletionComplete from '@/pages/MyPage/UserProfileEdit/DeletionComplete.vue';
import UserProfileEdit from '@/pages/MyPage/UserProfileEdit/UserProfileEdit.vue';
import UserProfileEditPhone from '@/pages/MyPage/UserProfileEdit/UserProfileEditPhone.vue';
import Notfound404 from '@/pages/Notfound404/Notfound404.vue';
import Notice from '@/pages/Notice/Notice.vue';
import NoticeDetail from '@/pages/Notice/NoticeDetail.vue';
import NotSubscribe from '@/pages/NotSubscribe/NotSubscribe.vue';
import Payment from '@/pages/Payment/Payment.vue';
import PaymentComplete from '@/pages/Payment/PaymentComplete.vue';
import PaymentFailed from '@/pages/Payment/PaymentFailed.vue';
import PostDetail from '@/pages/ProTips/PostDetail.vue';
import ProTips from '@/pages/ProTips/ProTips.vue';
import ReportJPN from '@/pages/Report/ReportJPN.vue';
import ReportKR from '@/pages/Report/ReportKR.vue';
import ReportUSA from '@/pages/Report/ReportUSA.vue';
import Subscribe from '@/pages/Subscribe/Subscribe.vue';
import SubscribeClosed from '@/pages/Subscribe/SubscribeClosed.vue';
import TopGaining from '@/pages/TopGaining/TopGaining.vue';
import TopGainingDetail from '@/pages/TopGaining/TopGainingDetail.vue';
import { useLoadingStore } from '@/stores/loading';
// store
import { useModalStore } from '@/stores/modal';
import { useTokenStore } from '@/stores/token';
import {
	checkLogin,
	checkLoginAuto,
	checkSubscribeAll,
	redirectPaymentLink,
	setCountry,
	setJpnCountry,
	setKrCountry,
	setUsaCountry,
} from '@/utils/function/login';

const routes = [
	{
		path: '/',
		name: 'HomeRedirect',
		redirect: '/home',
	},
	{
		//홈
		path: '/home',
		name: 'home',
		component: Home,
	},
	{
		//로그인
		path: '/auth/login',
		name: 'auth/login',
		component: Login,
		meta: { title: '로그인' },
	},
	{
		//로그인-약관동의
		path: '/auth/terms-agreement',
		name: 'auth/terms-agreement',
		component: TermsAgreement,
		meta: { title: '약관동의' },
		beforeEnter: [setKrCountry],
	},
	{
		//로그인-회원가입
		path: '/auth/signup',
		name: 'auth/signup',
		component: SignUp,
		meta: { title: '회원가입' },
		beforeEnter: [setKrCountry],
	},
	{
		//로그인-회원가입-완료
		path: '/auth/signup-complete',
		name: 'auth/signup-complete',
		component: SignUpComplete,
		meta: { title: '회원가입' },
		beforeEnter: [setKrCountry],
	},
	{
		//로그인-비밀번호찾기
		path: '/auth/find-pw',
		name: 'auth/find-pw',
		component: ForgotPassword,
		meta: { title: '비밀번호 찾기' },
		beforeEnter: [setKrCountry],
	},
	{
		//로그인-비밀번호찾기-패스워드 변경
		path: '/auth/change-pw',
		name: 'auth/change-pw',
		component: ChangePassword,
		meta: { title: '비밀번호 변경' },
		beforeEnter: [setKrCountry],
	},
	{
		//로그인-아이디찾기
		path: '/auth/find-id',
		name: 'auth/find-id',
		component: FindId,
		meta: { title: '아이디 찾기' },
		beforeEnter: [setKrCountry],
	},
	{
		//로그인-아이디찾기-결과
		path: '/auth/find-id-result',
		name: 'auth/find-id-result',
		component: FindIdResult,
		meta: { title: '아이디 찾기' },
		beforeEnter: [setKrCountry],
	},
	{
		// 관심종목(한국)
		path: '/interest/kr',
		name: 'interest/kr',
		component: InterestKR,
		meta: { title: '관심종목' },
		beforeEnter: [setKrCountry],
	},
	{
		// 관심종목(미국)
		path: '/interest/usa',
		name: 'interest/usa',
		component: InterestUSA,
		meta: { title: '관심종목' },
		beforeEnter: [setUsaCountry],
	},
	{
		// 관심종목(일본)
		path: '/interest/jpn',
		name: 'interest/jpn',
		component: InterestJPN,
		meta: { title: '관심종목' },
		beforeEnter: [setJpnCountry],
	},
	{
		//시장타이밍(한국)
		path: '/market-timing/kr',
		name: 'market-timing/kr',
		component: MarketTiming,
		meta: { title: '한국시장' },
		beforeEnter: [setKrCountry],
	},
	{
		//시장타이밍(미국)
		path: '/market-timing/usa',
		name: 'market-timing/usa',
		component: MarketTiming,
		meta: { title: '미국시장' },
		beforeEnter: [setUsaCountry],
	},
	{
		//시장타이밍(일본)
		path: '/market-timing/jpn',
		name: 'market-timing/jpn',
		component: MarketTiming,
		meta: { title: '일본시장' },
		beforeEnter: [setJpnCountry],
	},
	{
		//시장타이밍(한국업종)
		path: '/market-timing/sector/kr',
		name: 'market-timing/sector/kr',
		component: MarketTiming,
		meta: { title: '업종(한국)' },
		beforeEnter: [setKrCountry],
	},
	{
		//대가정보
		path: '/master-info',
		name: 'master-info',
		component: MasterInfo,
		meta: { title: '대가정보' },
		beforeEnter: [setKrCountry],
	},
	{
		//Hot 랭킹(한국)
		path: '/hot-ranking/kr',
		name: 'hot-ranking/kr',
		component: HotRankingKR,
		meta: { title: 'Hot 랭킹' },
		beforeEnter: [setKrCountry],
	},
	{
		//Hot 랭킹 상세(한국)
		path: '/hot-ranking-detail/kr/:pk/:categoryPk',
		name: 'hot-ranking-detail/kr',
		component: HotRankingDetailKR,
		meta: { title: '' },
		beforeEnter: [checkLogin, checkSubscribeAll, setKrCountry],
	},
	{
		//Hot 랭킹(미국)
		path: '/hot-ranking/usa',
		name: 'hot-ranking/usa',
		component: HotRankingUSA,
		meta: { title: 'Hot 랭킹' },
		beforeEnter: [setUsaCountry],
	},
	{
		//Hot 랭킹 상세(미국)
		path: '/hot-ranking-detail/usa/:pk/:categoryPk',
		name: 'hot-ranking-detail/usa',
		component: HotRankingDetailUSA,
		meta: { title: '' },
		beforeEnter: [checkLogin, checkSubscribeAll, setUsaCountry],
	},
	{
		//Hot 랭킹(일본)
		path: '/hot-ranking/jpn',
		name: 'hot-ranking/jpn',
		component: HotRankingJPN,
		meta: { title: 'Hot 랭킹' },
		beforeEnter: [setJpnCountry],
	},
	{
		//Hot 랭킹 상세(일본)
		path: '/hot-ranking-detail/jpn/:pk/:categoryPk',
		name: 'hot-ranking-detail/jpn',
		component: HotRankingDetailJPN,
		meta: { title: '' },
		beforeEnter: [checkLogin, checkSubscribeAll, setJpnCountry],
	},
	{
		//임시 결제 링크
		path: '/temp-payment',
		name: 'temp-payment',
		redirect: () => ({
			path: '/payment',
			query: {
				viaTempLink: '1',
			},
		}),
	},
	{
		//구독 안내
		path: '/subscribe/closed',
		name: 'subscribe-closed',
		component: SubscribeClosed,
		meta: { title: '구독 안내' },
	},
	{
		//구독전용
		path: '/subscribe',
		name: 'subscribe',
		component: Subscribe,
		meta: { title: '이달의 포착주' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//구독전용 없음
		path: '/subscribe/:country/not',
		name: 'not-subscribe',
		component: NotSubscribe,
		meta: { title: '구독전용' },
		beforeEnter: [checkLogin, setCountry],
	},
	{
		//노하우 공유
		path: '/protips',
		name: 'protips',
		component: ProTips,
		beforeEnter: [checkLogin],
	},
	{
		//노하우 공유 상세
		path: '/protips/post-detail/:pk',
		name: 'protips/post-detail',
		component: PostDetail,
		beforeEnter: [checkLogin],
	},
	{
		//투자리포트(한국)
		path: '/report/kr/:eventPk',
		name: 'report/kr',
		component: ReportKR,
		meta: { title: '투자리포트' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//투자리포트(미국)
		path: '/report/usa/:eventPk/:masterPk?',
		name: 'report/usa',
		component: ReportUSA,
		meta: { title: '투자리포트' },
		beforeEnter: [checkLogin, setUsaCountry],
	},
	{
		//투자리포트(일본)
		path: '/report/jpn/:eventPk/:masterPk?',
		name: 'report/jpn',
		component: ReportJPN,
		meta: { title: '투자리포트' },
		beforeEnter: [checkLogin, setJpnCountry],
	},
	{
		//대가종목(미국)
		path: '/master-stocks/usa',
		name: 'master-stocks/usa',
		component: MasterStocksUSA,
		meta: { title: '이달의 포착주' },
		beforeEnter: [checkLogin, setUsaCountry],
	},
	{
		//대가종목(일본)
		path: '/master-stocks/jpn',
		name: 'master-stocks/jpn',
		component: MasterStocksJPN,
		meta: { title: '이달의 포착주' },
		beforeEnter: [checkLogin, setJpnCountry],
	},

	{
		//상승률 상위 업종&테마
		path: '/topgaining',
		name: 'topgaining',
		component: TopGaining,
		meta: { title: '상승률 상위 업종&테마' },
		beforeEnter: [setUsaCountry],
	},
	{
		//상승률 상위 업종&테마 상세
		path: '/topgaining/topgaining-detail/:sort/:pk',
		name: 'topgaining/topgaining-detail',
		component: TopGainingDetail,
		meta: { title: '상승률 상위 업종&테마' },
		beforeEnter: [checkLogin, setUsaCountry, checkSubscribeAll],
	},

	{
		//ETF
		path: '/etf',
		name: 'etf',
		component: Etf,
		meta: { title: 'ETF' },
		beforeEnter: [setUsaCountry],
	},
	{
		//ETF Detail
		path: '/etf/detail/:etfPk/:etfEventPk',
		name: 'etf/detail',
		component: EtfDetail,
		meta: { title: 'ETF 상세' },
		beforeEnter: [checkLogin, setUsaCountry],
	},
	{
		//Sector(미국)
		path: '/sector/usa/:category',
		name: 'sector/usa',
		component: Sector,
		meta: { title: '' },
		beforeEnter: [checkLogin, setUsaCountry],
	},
	{
		//Sector(일본)
		path: '/sector/jpn/:category',
		name: 'sector/jpn',
		component: Sector,
		meta: { title: '' },
		beforeEnter: [checkLogin, setJpnCountry],
	},
	{
		//ETF Tab List
		path: '/etf/list/:category',
		name: 'etf/list',
		component: EtfTabList,
		meta: { title: 'ETF' },
		beforeEnter: [checkLogin, setUsaCountry, checkSubscribeAll],
	},
	{
		//큰손들의 실제 보유종목
		path: '/holdings',
		name: 'holdings',
		component: MajorHolder,
		meta: { title: '큰손들의 실제 보유종목' },
		beforeEnter: [checkLogin, setUsaCountry, checkSubscribeAll],
	},
	{
		//기업분석(미국)
		path: '/company-analysis/usa',
		name: 'company-analysis/usa',
		component: CompanyAnalysisUSA,
		meta: { title: '기업분석' },
		beforeEnter: [checkLogin, setUsaCountry],
	},
	{
		//기업분석(한국)
		path: '/company-analysis/kr',
		name: 'company-analysis/kr',
		component: CompanyAnalysisKR,
		meta: { title: '기업분석' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//기업분석(일본)
		path: '/company-analysis/jpn',
		name: 'company-analysis/jpn',
		component: CompanyAnalysisJPN,
		meta: { title: '기업분석' },
		beforeEnter: [checkLogin, setJpnCountry],
	},
	{
		//더보기-공지사항
		path: '/notice',
		name: 'notice',
		component: Notice,
		meta: { title: '공지사항' },
		beforeEnter: [setKrCountry],
	},
	{
		//더보기-공지사항 디테일
		path: '/notice-detail/:pk',
		name: 'notice-detail',
		component: NoticeDetail,
		beforeEnter: [setKrCountry],
	},

	{
		//더보기-대가의 혜택
		path: '/benefit',
		name: 'benefit',
		component: Benefit,
		meta: { title: '대가의 혜택' },
		beforeEnter: [setKrCountry],
	},
	// {
	// 	//더보기-대가의 타이밍
	// 	path: '/Timing',
	// 	name: 'Timing',
	// 	component: Timing,
	// 	meta: { title: '대가의 타이밍' },
	// 	beforeEnter: [setKrCountry],
	// },
	// {
	// 	//더보기-대가의 타이밍 상세
	// 	path: '/TimingDetail/:pk/:type',
	// 	name: 'TimingDetail',
	// 	component: TimingDetail,
	// 	beforeEnter: [checkLoginDetail, setKrCountry],
	// },
	{
		//더보기-대가의 혜택-구독전용게시판
		path: '/subscriber-board',
		name: 'subscriber-board',
		component: SubscriberBoard,
		meta: { title: '프리미엄' },
		beforeEnter: [setKrCountry],
	},
	{
		//더보기-대가의 혜택-구독전용게시판 상세
		path: '/subscriber-board-detail/:pk',
		name: 'subscriber-board-detail',
		component: SubscriberBoardDetail,
		beforeEnter: [checkLoginAuto, setKrCountry],
	},
	{
		//고객소리함
		path: '/feedback',
		name: 'feedback',
		component: CustomerFeedbackForm,
		meta: { title: '고객소리함' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지
		path: '/my',
		name: 'my',
		component: MyPage,
		meta: { title: '마이페이지' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역
		path: '/my/history',
		name: 'my/history',
		component: SubscriptionHistory,
		meta: { title: '구독내역' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보
		path: '/sub/details/:subscription_pk',
		name: 'sub/details',
		component: SubscriptionDetails,
		meta: { title: '구독 정보' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보-정기결제 내역
		path: '/sub/payment-history/:subscription_pk',
		name: 'payment-history',
		component: RecurringPaymentsList,
		meta: { title: '정기결제 내역' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보-구독해지
		path: '/sub/cancel/:subscription_pk',
		name: 'sub/cancel',
		component: CancelSubscriptionForm,
		meta: { title: '구독해지' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보-구독해지
		path: '/sub/cancel-reason/:subscription_pk',
		name: 'sub/cancel-reason',
		component: CancelSubscriptionReason,
		meta: { title: '구독해지' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보-구독해지확인
		path: '/sub/cancel-confirm/:subscription_pk',
		name: 'sub/cancel-confirm',
		component: CancelSubscriptionConfirm,
		meta: { title: '구독해지' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보-구독해지앱 권유 가이드 확인
		path: '/sub/cancel-app-guide/:subscription_pk',
		name: 'sub/cancel-app-guide',
		component: SubscriptionCancellationAppGuide,
		meta: { title: '구독해지' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-구독내역-구독정보-구독해지완료
		path: '/sub/cancel-complete/:subscription_pk',
		name: 'sub/cancel-complete',
		component: SubscriptionCancellationComplete,
		meta: { title: '구독해지' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-내정보변경
		path: '/my/edit',
		name: 'my/edit',
		component: UserProfileEdit,
		meta: { title: '내 정보 변경' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-내정보변경-휴대폰 번호 인증
		path: '/my/edit/phone',
		name: 'my/edit/phone',
		component: UserProfileEditPhone,
		meta: { title: '휴대폰 번호 인증' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-내정보변경-회원탈퇴
		path: '/my/edit/account-delete',
		name: 'my/edit/account-delete',
		component: AccountDeletion,
		meta: { title: '회원탈퇴' },
		beforeEnter: [setKrCountry],
	},
	{
		//마이페이지-내정보변경-회원탈퇴완료
		path: '/my/edit/account-delete-complete',
		name: 'my/edit/account-delete-complete',
		component: DeletionComplete,
		meta: { title: '회원탈퇴' },
		beforeEnter: [setKrCountry],
	},
	{
		//마이페이지-비밀번호변경
		path: '/my/pw-change',
		name: 'my/pw-change',
		component: PasswordChange,
		meta: { title: '비밀번호 변경' },
		beforeEnter: [checkLogin, setKrCountry],
	},

	{
		//마이페이지-새로운비밀번호변경
		path: '/my/pw-change/new-pw-change',
		name: 'my/pw-change/new-pw-change',
		component: NewPasswordChange,
		meta: { title: '비밀번호 변경' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//마이페이지-서비스이용약관
		path: '/my/terms-service',
		name: 'my/terms-service',
		component: TermsOfService,
		meta: { title: '서비스 이용약관' },
		beforeEnter: [setKrCountry],
	},
	{
		//마이페이지-개인정보처리방침
		path: '/my/privacy-policy',
		name: 'my/privacy-policy',
		component: PrivacyPolicy,
		meta: { title: '개인정보 처리방침' },
		beforeEnter: [setKrCountry],
	},

	{
		//구독결제 진입 링크
		path: '/payment-link',
		name: 'payment-link',
		component: Payment,
		meta: { title: '구독결제' },
		beforeEnter: [redirectPaymentLink],
	},
	{
		//구독결제
		path: '/payment',
		name: 'payment',
		component: Payment,
		meta: { title: '구독결제' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//구독결제-완료
		path: '/payment-complete',
		name: 'payment-complete',
		component: PaymentComplete,
		meta: { title: '구독결제 완료' },
		beforeEnter: [checkLogin, setKrCountry],
	},
	{
		//구독결제-실패
		path: '/payment-failed',
		name: 'payment-failed',
		component: PaymentFailed,
		meta: { title: '구독결제 실패' },
		beforeEnter: [checkLogin, setKrCountry],
	},

	{
		// 404 페이지
		path: '/404',
		name: '404',
		component: Notfound404,
	},
	{
		// 존재하지 않는 페이지 404로 리다이렉트
		path: '/:pathMatch(.*)*',
		redirect: '/404',
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			if (to.hash && from.hash !== to.hash) {
				// 다른 hash로 이동하는경우 부드럽게 해당 hash로 이동
				return {
					el: to.hash,
					behavior: 'smooth',
					top: 70, // header 높이만큼 더 내려서 이동
				};
			} else if (from.path.toLowerCase() !== to.path.toLowerCase()) {
				console.log('path', from.path, to.path);
				// path가 다른 경우 맨위로
				return { top: 0 };
			}
			// else if (from.fullPath === to.fullPath) {
			// 	// path, query, hash가 바뀌지 않은경우 부드럽게 위로 스크롤
			// 	return { top: 0, behavior: 'smooth' };
			// }
		}
	},
});

let loadingTimeId: ReturnType<typeof setTimeout>; // 페이지 변경시 로딩 시작
router.beforeEach((to, from) => {
	const tokenStore = useTokenStore();

	// =========================임시: 5월 중에 삭제 예정 START========================
	// /payment 경로는 /subscribe/closed로 리다이렉트
	// 단, viaTempLink 쿼리가 있는 경우는 통과
	if (to.path === '/payment' && to.query.viaTempLink === '1') {
		return true;
	}

	if (to.path === '/payment' && tokenStore.isLogin) {
		return { path: '/subscribe/closed', replace: true };
	}
	// =========================임시: 5월 중에 삭제 예정 END========================

	const modalStore = useModalStore();
	const loadingStore = useLoadingStore();
	// 모달창 닫기
	if (to.path !== from.path) {
		modalStore.closeAll();
	}
	// 1초뒤에 페이지로딩 시작
	clearTimeout(loadingTimeId); // 페이지로딩 시작 취소
	loadingTimeId = setTimeout(() => {
		loadingStore.startPageLoading();
	}, 300);
});
router.afterEach(() => {
	const loadingStore = useLoadingStore();
	clearTimeout(loadingTimeId); // 페이지로딩 시작 취소
	loadingStore.finishPageLoading();
});

export default router;
